var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('small',{staticClass:"form-text text-muted topped"},[_vm._v("Updox v2016.0 ˙ © 2020 Updox")])])
}]

export { render, staticRenderFns }